module.exports = __webpack_public_path__ + "img/sponsors.f058c625.svg";